import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import notificationsService from '../services/notificationsService';

export const useNotificationsQuery = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['notifications', params],
    queryFn: () => notificationsService.getNotifications(params),
    ...options,
  });
};

export const useUnreadNotificationsCountQuery = (options = {}) => {
  return useQuery({
    queryKey: ['notifications', 'unreadCount'],
    queryFn: () => notificationsService.getUnreadCount(),
    ...options,
  });
};

export const useMarkNotificationReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId) => notificationsService.markAsRead(notificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['notifications', 'unreadCount'] });
    },
  });
};

export const useMarkAllNotificationsReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsService.markAllAsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
      queryClient.invalidateQueries({ queryKey: ['notifications', 'unreadCount'] });
    },
  });
};
